function openIngredientTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontentIngredient");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinksIngredient");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" activeIngredient", "");
  }
  document.getElementById(cityName).style.display = "flex";
  evt.currentTarget.className += " activeIngredient";
}
document.querySelectorAll(".tablinksIngredient")[0].click();

(function() {
    if (typeof tns === 'undefined') {
      console.error('Tiny Slider is not loaded');
      return;
    }

    var innerSliderLook = document.querySelectorAll(".innersliderIngredient");
    var tempInnerSlider = [];
    for (var i = 0, len = innerSliderLook.length; i < len; i++) {
      var innerSliderSingleLook = innerSliderLook[i];
      if (innerSliderSingleLook && innerSliderSingleLook.children.length > 0 && innerSliderSingleLook.parentNode && innerSliderSingleLook.parentNode.nodeType === 1) {
        try {
          var innerSliderInstance = tns({
            container: innerSliderSingleLook,
            items: 1,
            slideBy: 1,
            controls: true,
            nav: false,
            loop: false,
            autoplay: false,
            gutter: 0
          });
          tempInnerSlider[i] = innerSliderInstance;
        } catch (e) {
          console.error('Ingredient inner slider init error:', e);
        }
      }
    }

    var SliderLook = document.querySelectorAll(".ingredientSlider");
    var tempSlider = [];
    for (var i = 0, len = SliderLook.length; i < len; i++) {
      var SliderSingleLook = SliderLook[i];
      if (SliderSingleLook && SliderSingleLook.children.length > 0 && SliderSingleLook.parentNode && SliderSingleLook.parentNode.nodeType === 1) {
        try {
          // Calculate startIndex to center the active slide
          var slideCount = SliderSingleLook.children.length;
          var startIndex = Math.floor(slideCount / 2);
          
          var sliderInstance = tns({
            container: SliderSingleLook,
            items: 1,
            slideBy: 1,
            controls: true,
            nav: false,
            loop: true,
            mouseDrag: true,
            autoplay: false,
            gutter: 0,
            center: true,
            startIndex: startIndex,
            responsive: { 
              640: { items: 2 },
              900: { items: 3 },
              1200: { items: 4 }
            }
          });
          tempSlider[i] = sliderInstance;
        } catch (e) {
          console.error('Ingredient slider init error:', e);
        }
      }
    }

    function runMe(element) {
      // Tiny Slider auto-handles resize, no manual refresh needed
    }

    function resizeMe() {

    }

    MicroModal.init({
      onShow: modal => runMe(),
      openClass: 'show'
    });
    
    document.querySelector(".ingredient-accordion").click();   
})();
 